import { Injectable } from '@angular/core';
import { AuthGroup, UserType, UserTypeId } from 'src/app/shared/models/userType.model';
import { UserGroupModel } from 'src/app/admin/models/group.model';
import { Constants } from 'src/app/shared/constants';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { GlobalsessionhandlerService } from './globalsessionhandler.service';
@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    private permissionhit = false;
    private _jsonURL = 'assets/AccessBasedOnUserType.json';
    //permissions:UserGroupModel[]=[] ; // Store the actions for which this user has permission
    rolePriority: string;
    constant: Constants = new Constants();

    constructor(private baseHttpService: BaseHttpService, private sessionhandleservice: GlobalsessionhandlerService) {

        this.getJSON().subscribe(data => {
            this.rolePriority = data;
        });
    }
    private getJSON(): Observable<any> {
        return this.baseHttpService.get(this._jsonURL);
    }

    hasRequiredPermission(authGroup: AuthGroup, groupId: string, e1: any): Promise<boolean> | boolean {
        //console.log("hasReqpermmision");
        //
        //console.log(this.sessionhandleservice.getuserpermission());
        // If user’s permissions already retrieved from the API
        if (this.sessionhandleservice.getuserpermission() && this.sessionhandleservice.getuserpermission().length > 0) {

            if (authGroup) {
                return this.hasPermission(authGroup, groupId, e1);
            } else {
                return this.hasPermission(null, null, e1);
            }
        } else {
            //
            // Otherwise, must request permissions from the API first
            // if(!this.sessionhandleservice.getAuthorizationflag())
            // {
            const promise = new Promise<boolean>((resolve, reject) => {
                if (this.permissionhit == false) {
                    this.initializePermissions()
                        .then(() => {
                            if (authGroup) {
                                resolve(this.hasPermission(authGroup, groupId, e1));
                            } else {
                                resolve(this.hasPermission(null, null, e1));
                            }
                        }).catch(() => {
                            resolve(false);
                        });
                }
            });
            this.sessionhandleservice.setAuthorizationflag(true);
            return promise;
            // }
        }
    }


    protected hasPermission(authGroup: AuthGroup, GroupId: string, e1: any) {
        //
        //console.log("hasPermission");
        if (this.sessionhandleservice.getuserpermission()) {
            let isSuperAdmin = this.sessionhandleservice.getuserpermission().find(x => x.userTypeDesc == UserType["Super Admin"]);
            //superadmin has access to all 
            if (isSuperAdmin) {
                return true;
            }
            //other roles should have access as per user type and org /group mapping
            let roleId = UserTypeId[authGroup];
            if (this.rolePriority == "" || this.rolePriority == null || this.rolePriority == undefined) {
                this.getJSON().subscribe(x => {
                    this.rolePriority = x;
                    let priority = this.rolePriority["AccessPriority"];
                    let userRolePriority = priority.find(x => x["UserType"] == roleId);
                    let hasAccess = false;
                    if (GroupId == "-1") {

                        let distinctUserType = this.sessionhandleservice.getuserpermission().map(x => x.userTypeDesc).filter(
                            (thing, i, arr) => arr.findIndex(t => t === thing) === i
                        );

                        distinctUserType.forEach(element => {
                            let elemntRoleId = UserTypeId[element];
                            let userRolePriorityForElement = priority.find(x => x["UserType"] == elemntRoleId)["Priority"];
                            if (userRolePriority["Priority"] >= userRolePriorityForElement) {
                                hasAccess = true;
                                return true;
                            }
                        });
                    }
                    else {
                        let distinctUserType = this.sessionhandleservice.getuserpermission().filter(x => x.groupId == GroupId).map(x => x.userTypeDesc).filter(
                            (thing, i, arr) => arr.findIndex(t => t === thing) === i
                        );

                        distinctUserType.forEach(element => {
                            let elemntRoleId = UserTypeId[element];
                            let userRolePriorityForElement = priority.find(x => x["UserType"] == elemntRoleId)["Priority"];
                            if (userRolePriority["Priority"] >= userRolePriorityForElement) {
                                hasAccess = true;
                                return true;
                            }
                        });
                    }
                    if (hasAccess) {
                        return true;
                    }
                    let validAccess = this.sessionhandleservice.getuserpermission().find(permission => permission.groupId === GroupId && permission.userTypeDesc == authGroup);
                    if (validAccess) {
                        return true;
                    }
                    if (e1 != null) {
                        e1.style.display = 'none';
                    }
                    return false;
                });
            }
            else {
                let priority = this.rolePriority["AccessPriority"];
                let userRolePriority = priority.find(x => x["UserType"] == roleId);
                let hasAccess = false;
                if (GroupId == "-1") {

                    let distinctUserType = this.sessionhandleservice.getuserpermission().map(x => x.userTypeDesc).filter(
                        (thing, i, arr) => arr.findIndex(t => t === thing) === i
                    );

                    distinctUserType.forEach(element => {
                        let elemntRoleId = UserTypeId[element];
                        let userRolePriorityForElement = priority.find(x => x["UserType"] == elemntRoleId)["Priority"];
                        if (userRolePriority["Priority"] >= userRolePriorityForElement) {
                            hasAccess = true;
                            return true;
                        }
                    });
                }
                else {
                    let distinctUserType = this.sessionhandleservice.getuserpermission().filter(x => x.groupId == GroupId).map(x => x.userTypeDesc).filter(
                        (thing, i, arr) => arr.findIndex(t => t === thing) === i
                    );

                    distinctUserType.forEach(element => {
                        let elemntRoleId = UserTypeId[element];
                        let userRolePriorityForElement = priority.find(x => x["UserType"] == elemntRoleId)["Priority"];
                        if (userRolePriority["Priority"] >= userRolePriorityForElement) {
                            hasAccess = true;
                            return true;
                        }
                    });
                }
                if (hasAccess) {
                    return true;
                }
                let validAccess = this.sessionhandleservice.getuserpermission().find(permission => permission.groupId === GroupId && permission.userTypeDesc == authGroup);
                if (validAccess) {
                    return true;
                }
            }
            if (e1 != null) {
                e1.style.display = 'none';
            }
            return false;
        }
    }




    // This method is called once and a list of permissions is stored in the permissions property
    initializePermissions() {
        this.permissionhit = true;
        if (this.permissionhit == true) {
            //
            //console.log("initialize"); 
            return new Promise((resolve, reject) => {
                // Call API to retrieve the list of actions this user is permitted to perform. (Details not provided here.)
                // In this case, the method returns a Promise, but it could have been implemented as an Observable
                this.baseHttpService.get(this.constant.getAllGrpByOrg).subscribe(permissions => {
                    
                    this.sessionhandleservice.setuserpermission(permissions);
                    this.permissionhit = false;
                    resolve(null);
                });

            });
        }
    }
}
